
export const directBillClients = ['ICBC', 'Lawyer', 'DTP', 'CVAP', 'CFSEU', 'EAP', 'FNHA']

export const directBillComment = "These sessions will show up on your future invoice once paperwork is caught up."
export const notDirectBillComment = "These sessions will show up on your future invoice once sessions have been charged."
export const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const phoneRegex = /^(\+1)(\d{2})(\d{3})(\d{2})(\d{3})$/
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const phoneInputLabel = "The phone number needs to be a cell phone that can receive text messages"
export const invalidPhoneMessage = "Please enter a valid phone number"
export const differentPhonesMessage = "Phones do not match"

export const requiredMessage = "This field is required"

export const invalidPasswordMessage = "Your password should contain at least one numeric, one lowercase and one uppercase letter and should be at least 8 characters long"
export const differentPasswordsMessage = "Passwords do not match"

export const invalidEmailMessage = "Please enter a valid email address"

export const notAuthedMessage = "User is not authenticated"

export const phoneSuccessMessage = {
    title: "Phone updated successfully",
    message: "Success",
    type: "success"
}

export const passwordSuccessMessage = {
    title: "Password updated successfully",
    message: "Success",
    type: "success"
}

export const failedMessage = {
    title: "Something wrong",
    message: "Please try again later",
    type: "error"
}

export const emailFailed = {
    message: "This email is not registered in Acuity. Please enter your Acuity login or contact your NFC Admin for more details",
    title: "Email failed",
    type: "error"
}

export const loginSuccessMessage = {
    title: "Login Success",
    message: "Success",
    type: "success",
}

export const loginFailedMessage = {
    title: "Login Failed",
    message: "Login failed, please try again",
    type: "error",
}

export const registrationFailedMessage = {
    title: "Registration Failed",
    message: "Registration failed, please try again",
    type: "error",
}

export const registrationSuccessMessage = {
    title: "Registration Success",
    message: "Success",
    type: "success",
}

export const emailSuccessMessage = {
    title: "Email sended successfully",
    message: "Success",
    type: "success",
}

export const passwordSendMessage = {
    title: "We've emailed your password to the email you entered.",
    message: "Success",
    type: "success",
}


export const SETTINGS_FOR_EXPORT = {
    fileName: 'Exported Invoices',
    workSheets: [
      {
        sheetName: 'Exported invoices',
        startingRowNumber: 1,
        tableSettings: {
          data: {
            headerDefinition: [
              {
                type: "text",
                name: 'Invoice Number',
                key: 'invoiceNumber',
                width: 18
              },
              {
                name: 'Claim Number',
                key: 'claimNumber',
                width: 18
              },
              {
                name: 'Invoice Date',
                key: 'invoiceDate',
                width: 20
              },
              {
                name: 'Client',
                key: 'client',
                width: 30,
              },
              {
                name: 'Therapist',
                key: 'therapist',
                width: 30,
              },
              {
                name: 'Number of Appointments',
                key: 'numberOfAppointments',
                width: 25,
              },
              {
                name: 'Invoice Total',
                key: 'invoiceTotal',
                width: 18,
                alignment: 'left',
                caption: 'text',
                type: "string",
              },
            ],
          },
        },
      },
    ],
  };

export const alertTypes = {
    red: "red",
    blue: "blue",
    yellow: "yellow",
    grey: "grey",
    pink: "pink"
} 

export const legendTypes = {
    submited: "submited",
    noApproval: "no-approval",
    noPayment: "no-paiment",
    partialCharge: "partial-charge",
    request: "request"
}

export const mockGrops = [
    {
        type: "Remote",
        groupedItems: [
            {
              date: 'Jan 1, 2022',
              items: [
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                // {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                // {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                // {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                // {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
              ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            }
        ]
    },
    {
        type: "Deactivated",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "Past",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "Marked",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "No show",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "Availability",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "Space",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    },
    {
        type: "Initial Report",
        groupedItems: [
            {
                date: 'Jan 1, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 2, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 4, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
            {
                date: 'Jan 5, 2022',
                items: [
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"},
                    {id: 1, name: "Moshko Sergey", date: "Jan 31, 2022"},
                    {id: 2, name: "Vlad Bulat", date: "Jan 31, 2022"},
                    {id: 3, name: "Olesia Zhin", date: "Jan 31, 2022"},
                    {id: 4, name: "Dmitry Backend", date: "Jan 31, 2022"},
                    {id: 5, name: "Helena Rodrigez", date: "Jan 31, 2022"}
                ]
            },
        ]
    }
]